import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_STATE_LIST,
    CLEAR_STATE_LIST_ERROR,
    LOAD_STATE_LIST_REQUEST,
    LOAD_STATE_LIST_SUCCESS,
    LOAD_STATE_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_STATE_LIST,
    CLEAR_ERROR: CLEAR_STATE_LIST_ERROR,
    LOAD_REQUEST: LOAD_STATE_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_STATE_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_STATE_LIST_FAILURE
}